import React from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Spinner } from 'reactstrap'
import { Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import withAppconfig from '../../AppContext'
import { useAddCard } from '../../utils/addcard'
import RecurringCardConsentNote from '../RecurringCardConsentNote'

// The /addcard page's button: fetches signed Paytrail tokenization parameters on click and posts
// them to Paytrail's add-card form (utils/addcard.js, shared with the membership pages). The
// backend builds the redirect urls from the returnurl we pass (validated server-side against
// venue hosts).
function SaveCard({ appconfig }) {
  const history = useHistory()
  const { t } = useTranslation()
  const { start, starting, failed } = useAddCard({ appconfig })
  // the optional recurring-bookings consent for this card (RecurringCardConsentNote), unticked by default
  const [recurringConsent, setRecurringConsent] = React.useState(false)

  if (failed) {
    return (
      <div style={{ textAlign: 'center', padding: 20 }}>
        <Typography variant='body2' style={{ marginBottom: 15 }}>
          {t('card_add_failed_init')}
        </Typography>
        <Button size='sm' color='primary' disabled={starting} onClick={start}>
          {starting ? <Spinner size='sm' /> : t('retry')}
        </Button>{' '}
        <Button size='sm' color='link' onClick={() => history.push(appconfig.pathPrefix + '/profile')}>
          {t('back')}
        </Button>
      </div>
    )
  }

  return (
    <div style={{ textAlign: 'center' }}>
      <Button color='primary' disabled={starting} onClick={() => start({ recurringConsent })}>
        {starting ? <Spinner size='sm' /> : t('save_card')}
      </Button>
      <RecurringCardConsentNote checked={recurringConsent} onChange={setRecurringConsent} style={{ maxWidth: 420, margin: '10px auto 0' }} />
    </div>
  )
}

export default withAppconfig(SaveCard)
